<div class="flex-row padding-top-bottom">

    <div class="flex-1"></div>

    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="form-content border padding-20 small-text">
        <h1 class="center-text">Customer Portal</h1>

        <h2 class="center-text">Change Password</h2>

        <p>Password must meet the following criteria:</p>

        <ul>
            <li>Minimum eight characters</li>

            <li>At least one upper case letter</li>

            <li>At least one lower case letter</li>

            <li>At least one digit</li>

            <li>At least one special of the following special character<br/>#?!@$^&*-</li>
        </ul>

        <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>

            <input type="password" matInput formControlName="password">

            @if (formControls.password.hasError('required')) {
                <mat-error>Password is required.</mat-error>
            }

            @if(formControls.password.hasError('pattern')) {
                <mat-error>Password does not meet requirements.</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>

            <input type="password" matInput formControlName="confirmPassword">

            @if (formControls.confirmPassword.hasError('required')) {
                <mat-error>Confirm Password is required.</mat-error>
            }

            @if (formControls.confirmPassword.hasError('notSame')) {
                <mat-error>Passwords must match.</mat-error>
            }

        </mat-form-field>

        @if (error.length > 0) {
            <div class="error-text error-padding error-width">
                {{error}}
            </div>
        }

        <div class="flex-row">
            @if (saving) {
                <mat-progress-bar style="height: 5px; width: 100%;" mode="indeterminate"></mat-progress-bar>
            }
        </div>

        @if (!saving) {
            <div class="form-group padding-top-30">
                <button style="border-radius: 4px;" mat-raised-button color="primary" [disabled]="loading || !changePasswordForm.valid" class="btn btn-primary width-100" type="submit">
                    Submit
                </button>

                <div class="flex-row">
                    <div class="flex-1"></div>

                    @if (loading) {
                        <mat-spinner></mat-spinner>
                    }

                    <div class="flex-1"></div>
                </div>

                <a mat-stroked-button style="border-radius: 4px;" color="primary" routerLink="/login" routerLinkActive="forgot-password" class="width-100">
                Back to Login
                </a>
            </div>
        }
    </form>

    <div class="flex-1"></div>
</div>